<template>
    <b-modal
        v-model="shown"
        centered
        :title="title"
        lazy
    >
        <b-container fluid>
            <b-row>
                <b-form-group class="mb-0 w-100">
                    <AbsoluteOrRelativeCurrencyToggleInputGroup
                        :input-placeholder="fixed ? 'Enter unit price...' : 'Enter percentage change...'"
                        :input-invalid="$v.unitPrice.$anyError"
                        input-validation-required-message="Please enter a unit price amount."
                        checkbox-label="Fixed"
                        checkbox-hint="Use a fixed unit price value (e.g. £100) instead of a percentage change.
                            Percentage change may be negative but not zero."
                        @value="(value) => (unitPrice) = value"
                        @fixed="(isAbsolute) => (fixed) = isAbsolute"
                    />
                </b-form-group>
                <b-form-group v-if="!fixed">
                    <b-form-radio
                        v-model="source"
                        value="unit_price"
                    >
                        Mark up current prices
                    </b-form-radio>
                    <b-form-radio
                        v-model="source"
                        value="unit_cost"
                    >
                        Mark up unit cost
                    </b-form-radio>
                    <b-form-radio
                        v-model="source"
                        value="margin"
                    >
                        Set margin
                    </b-form-radio>
                </b-form-group>
            </b-row>
        </b-container>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading || $v.$invalid"
                :loading="submitLoading"
                @click="handleSubmit"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { required, decimal } from 'vuelidate/lib/validators';
import vueComponentReset from '@ianwalter/vue-component-reset';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    loading: false,
    submitLoading: false,
    unitPrice: '',
    fixed: false,
    source: 'unit_price',
}));

export default {

    mixins: [
        resetMixin,
    ],

    computed: {
        selectedCostIds() {
            return this.$store.getters['costable/selectedCostIds'];
        },
        selectedCostCount() {
            return this.selectedCostIds.length;
        },
        title() {
            return `Change unit price for ${this.selectedCostCount} Costs`;
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openChangeUnitPriceModal, () => {
            this.$v.$reset();
            this.reset();
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            if (this.fixed) {
                await this.$store.dispatch('costable/patchCosts', {
                    costIds: this.selectedCostIds,
                    data: { unit_price: this.unitPrice },
                });
            } else {
                let multiplier = this.unitPrice / 100;
                let source = this.source;

                if (this.source === 'margin') {
                    multiplier = multiplier / (1 - multiplier);
                    source = 'unit_cost';
                }

                await this.$store.dispatch('costable/patchCostsMultiplier', {
                    costIds: this.selectedCostIds,
                    data: { unit_price: multiplier, source },
                });
            }
            this.submitLoading = false;
            this.handleClose();
        },
        handleClose() {
            this.shown = false;
        },
    },

    validations: {
        unitPrice: {
            required,
            decimal,
            disallowZeroPercentage(value) {
                return this.fixed ? true : value !== '0';
            },
        },
    },

};
</script>
